// extracted by mini-css-extract-plugin
export default {"nav":"style_nav__lnPta","header":"style_header__Qolfs"};